'use es6';

import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { jsx as _jsx } from "react/jsx-runtime";
import I18n from 'I18n';
import { Provider } from 'react-redux';
import AppContainer from './AppContainer';
import defaultClient from 'hub-http/clients/apiClient';
import FormState from 'MeetingsLib/models/FormState';
import TrackingParams from 'MeetingsLib/models/TrackingParams';
import { createStore } from 'MeetingsLib/utils/createStore';
export default function createBookingComponent(_ref) {
  var _ref$httpClient = _ref.httpClient,
      httpClient = _ref$httpClient === void 0 ? defaultClient : _ref$httpClient,
      _ref$embedded = _ref.embedded,
      embedded = _ref$embedded === void 0 ? true : _ref$embedded,
      slug = _ref.slug,
      _ref$formState = _ref.formState,
      formState = _ref$formState === void 0 ? {} : _ref$formState,
      forceOffline = _ref.forceOffline,
      _ref$timezone = _ref.timezone,
      timezone = _ref$timezone === void 0 ? I18n.moment.tz.guess() : _ref$timezone,
      _ref$initTrackingForM = _ref.initTrackingForMeetings,
      initTrackingForMeetings = _ref$initTrackingForM === void 0 ? true : _ref$initTrackingForM,
      _ref$trackingParams = _ref.trackingParams,
      trackingParams = _ref$trackingParams === void 0 ? {} : _ref$trackingParams,
      onSuccess = _ref.onSuccess,
      onFailure = _ref.onFailure,
      locale = _ref.locale,
      forceMobile = _ref.forceMobile,
      _ref$parentPageHSAnal = _ref.parentPageHSAnalyticsInfo,
      parentPageHSAnalyticsInfo = _ref$parentPageHSAnal === void 0 ? {} : _ref$parentPageHSAnal,
      _ref$troubleshooting = _ref.troubleshooting,
      troubleshootingActive = _ref$troubleshooting === void 0 ? false : _ref$troubleshooting,
      _ref$forcePropertyFor = _ref.forcePropertyForm,
      forcePropertyForm = _ref$forcePropertyFor === void 0 ? null : _ref$forcePropertyFor,
      _ref$allowTroubleshoo = _ref.allowTroubleshootMode,
      allowTroubleshootMode = _ref$allowTroubleshoo === void 0 ? false : _ref$allowTroubleshoo,
      _ref$allowRedirect = _ref.allowRedirect,
      allowRedirect = _ref$allowRedirect === void 0 ? false : _ref$allowRedirect,
      disabledHsPopups = _ref.disabledHsPopups,
      _ref$disablePrefill = _ref.disablePrefill,
      disablePrefill = _ref$disablePrefill === void 0 ? false : _ref$disablePrefill,
      _ref$isRescheduling = _ref.isRescheduling,
      isRescheduling = _ref$isRescheduling === void 0 ? false : _ref$isRescheduling,
      _ref$meetingChangeId = _ref.meetingChangeId,
      meetingChangeId = _ref$meetingChangeId === void 0 ? null : _ref$meetingChangeId;
  var formStateFromParams = FormState.from(formState);
  var store = createStore({
    userSlug: slug,
    embedded: embedded,
    forceOffline: forceOffline,
    trackingParams: new TrackingParams(trackingParams),
    initialFormState: formStateFromParams,
    stagedFormState: formStateFromParams,
    formState: null,
    currentTime: I18n.moment().valueOf(),
    userTimezone: timezone,
    initTrackingForMeetings: initTrackingForMeetings,
    isRescheduling: isRescheduling,
    meetingChangeId: meetingChangeId,
    onSuccess: onSuccess,
    onFailure: onFailure,
    activeLocale: locale,
    forceMobile: forceMobile,
    parentPageHSAnalyticsInfo: parentPageHSAnalyticsInfo,
    troubleshooting: {
      active: troubleshootingActive
    },
    forcePropertyForm: forcePropertyForm,
    allowTroubleshootMode: allowTroubleshootMode,
    allowRedirect: allowRedirect,
    disablePrefill: disablePrefill
  }, httpClient);

  if (disabledHsPopups) {
    var _window$disabledHsPop;

    if (!window.disabledHsPopups) {
      window.disabledHsPopups = [];
    }

    (_window$disabledHsPop = window.disabledHsPopups).push.apply(_window$disabledHsPop, _toConsumableArray(disabledHsPopups));
  }

  return function (props) {
    return /*#__PURE__*/_jsx(Provider, {
      store: store,
      children: /*#__PURE__*/_jsx(AppContainer, Object.assign({}, props))
    });
  };
}